export default __webpack_public_path__ + "static/media/Oval@2x.6769939f.png";